import React from 'react';
import { Tag } from 'antd';

const STYLES = {
  'No Changes': { background: '#D6E4F7', color: '#1A3C7A', border: 'none' },
  'Incidental': { background: '#7FA3D4', color: '#fff', border: 'none' },
  'Minor': { background: '#4A72A8', color: '#fff', border: 'none' },
  'Major': { background: '#1A3C7A', color: '#fff', border: 'none' },
  'Out of Scope': { background: '#e8e8e8', color: '#888', border: '1px dashed #bbb' },
};

const SHORT = {
  'No Changes': 'No Changes',
  'Incidental': 'Incidental',
  'Minor': 'Minor',
  'Major': 'Major',
  'Out of Scope': 'Out of Scope',
};

const ClassificationTag = ({ classification, style }) => {
  if (!classification) return null;

  const tagStyle = STYLES[classification] || { background: '#e8e8e8', color: '#333', border: 'none' };

  return (
    <Tag style={{ ...tagStyle, borderRadius: 8, fontWeight: 600, ...style }}>
      {SHORT[classification] || classification}
    </Tag>
  );
};

export default ClassificationTag;
